/**
 * @file_purpose  page for showing login form of onboarding candidate login
 * @author Sucheta Singha
 * @Date_Created 27-02-2025
 * @Date_Modified 27-02-2025
 */
import React, { useState, useEffect } from 'react'
import { withRouter, useHistory, useParams } from 'react-router-dom'
import {
    CForm,
    CInput,
    CInputGroup,
    CLabel,
    CSelect
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import Constants from 'src/Utility/Constants';
import OnBoardingService from "src/apis/OnBoardingService";
import RouteURL from "src/apis/ApiURL";
import LoginImage from "src/assets/icons/log_img.png"
import blueOverlay from "src/assets/icons/blue_overlay.png"
import Visit from "src/assets/icons/visit_apple.png"

const OnBoardEmployeeLogin = (props) => {
    const history = useHistory();
    let { token } = useParams();
    //Define states
    const [state, setState] = useState({
        email: "",
        otp: ""
    })
    const [loadingData, setLoadingData] = useState(true);
    const [candidateDetails, setCandidateDetails] = useState({});
    const [otpErrors, setOtpErrors] = useState();
    const handleChange = (e) => {
        const { id, value } = e.target
        setState(prevState => ({
            ...prevState,
            [id]: value
        }))
    }
    localStorage.setItem("candidate_onboard_token", token);
    useEffect(() => {
        if (localStorage.getItem("candidate_onboard_verified") === "yes") {
            history.push(`/onboarding-form`);
            window.location.reload();
        } else if (localStorage.getItem("candidate_onboard_auth_token")) {
            history.push(`/onboarding-details`);
            window.location.reload();
        }


        /**
     * @author Sucheta Singha
     * @Date_Created 27-02-2025
     * @Date_Modified 27-02-2025
     * @function async
     * @functionName loadCandidateDetails
     * @functionPurpose this function gets candidate details.
     *
     * @functionParam {}
     *
     * @functionSuccess Success status and message.
     *
     * @functionError {Boolean} error is there.
     * @functionError {String} message  Description message.
     */

        async function loadCandidateDetails() {
            let params = JSON.stringify({
                token: token,
            })
            OnBoardingService.apiPostCallRequestWithoutToken(RouteURL.getOnBoardingCandidateDetails, params)
                .then((res) => {
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        const data = res.data[0];
                        setCandidateDetails(data)
                        setLoadingData(false);
                    } else {
                        toast.error(res.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                });
        }

        if (loadingData) {
            // if the result is not ready so you make the axios call
            loadCandidateDetails()
        }

    }, [loadingData]);


    /* Validation Checking */
    const ValidateForm = (e) => {
        e.preventDefault();
        if (handleValidation()) {
            VerifyOnBoardingCandidate();
        }
        else {
            toast.error("Please fill all the fields !", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    }

    /* Validate all fields */
    const handleValidation = (e) => {
        let otpErrors;
        let formIsValid = true;

        // password

        if (!state.otp) {
            formIsValid = false;
            otpErrors = "OTP can not be empty";
            setOtpErrors(otpErrors);
        } else {
            setOtpErrors('');
        }

        return formIsValid;
    }


    /**
    * @author Sucheta Singha
    * @Date_Created 27-02-2025
    * @Date_Modified 27-02-2025
    * @function sync
    * @functionName VerifyOnBoardingCandidate
    * @functionPurpose this function submit on boarding candidate  login form data.
    *
    * @functionParam {payload object:job_application_id,otp}
    * 
    * @functionSuccess Success status and message.
    *
    * @functionError {Boolean} error error is there.
    * @functionError {String} message  Description message.
    */


    const VerifyOnBoardingCandidate = (e) => {
        let params = JSON.stringify({
            verification_code: state.otp,
            token: token
        })
        OnBoardingService.apiPostCallRequestWithOnBoardToken(RouteURL.verifyOnBoardingCandidate, params)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    localStorage.setItem("candidate_onboard_auth_token", res.token);
                    toast.success(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    history.push("/onboarding-details");
                    window.location.reload();
                }
                else {
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }).catch(error => {
                console.log(error);
            })
    }


    return (

        <>
            <ToastContainer />
            <div className="signin_sec">
                <div className="overlay_sec">
                    <img src={blueOverlay} alt='' />
                </div>
                <div className="container-fluid">
                    <div className="row" style={{ marginTop: '90px' }}>
                        <div className="col-sm-12">
                            <div className="logo">
                                {/* <img src={Logo} alt='' /> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-4 col-sm-12">
                            <div className="login_left_sec">
                                <h2><span>Welcome to</span> <br />Red Apple Onboarding <br /> System </h2>
                                <img src={LoginImage} alt='' />
                            </div>
                        </div>
                        <div className="col-xxl-2 col-xl-2 col-lg-1 col-md-1 col-sm-12"></div>
                        <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-7 col-sm-12">
                            <div className="login_sec">
                                <ToastContainer />

                                <div>
                                    <CForm className="commentForm" onSubmit={ValidateForm}>
                                        <div className="visit_inn">
                                            <span className="visit_apple"> <img src={Visit} alt='' /></span>
                                            <h6>Welcome  <strong>{candidateDetails?.name}</strong></h6>
                                        </div>

                                        <div class="login_inner">
                                            <CLabel htmlFor="text-input">Email <span style={{ color: "red" }}>  * </span></CLabel>
                                            <CInput type="text" value={candidateDetails?.email} disabled
                                            />
                                        </div>

                                        <div class="login_inner">
                                            <CLabel htmlFor="text-input">OTP <span style={{ color: "red" }}>  * </span></CLabel>
                                            <CInputGroup>
                                                <CInput placeholder="OTP" id="otp" value={state.otp}
                                                    onChange={handleChange}
                                                    type="text"
                                                />
                                            </CInputGroup>
                                            <span style={{ color: "red" }}>{otpErrors}</span>
                                        </div>

                                        <button type="submit" className="login_btn">Login</button>

                                    </CForm>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>

    )
}

export default OnBoardEmployeeLogin
